<template>
  <div class="form">
    <div class="container">
      <div class="form-container text-left">
        <button @click="$router.go(-1)" class="app-btn px-3 mb-4">
          <v-icon class="mr-3 white-icon" name="arrow-left" scale="1"/> Atrás
        </button>
        <div class="d-flex justify-content-between">
          <span>
            <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
            Fecha de solicitud: {{requestDetail.createdDate | formatDate}}
          </span>
          <div class="d-flex">
            <div class="application-number mr-2">
              Solicitud - <span v-if="requestDetail.conectionType == 'Simple'">UPB</span> <span v-if="requestDetail.conectionType == 'Compleja'">UPM</span>
            </div>
            <div class="application-number">
              #{{requestDetail.id}}
            </div>
          </div>
        </div>
        <h2>Actividades de supervisión de obra</h2>
        <div class="input-wrap">
          <select name="via-type" id="via-type-1" v-model="monitoringActivity.title">
              <option value="Cargar documento RETIE">Cargar documento RETIE</option>
              <option value="Novedad de reaprobación de diseño">Novedad de reaprobación de diseño</option>
              <option value="otros">otros</option>
            </select>
            <textarea placeholder="Descripción de la actividad" v-model="monitoringActivity.comments" id="monitoringComments" cols="10" rows="5"></textarea>
            <div v-if="arrayDocuments.length > 0" class="alert alert-info mb-3">
              <h3>Documentos anexos</h3>
              <div class="mb-2 d-flex" v-for="(item, index) in arrayDocuments" :key="index">
                - {{item.description}} - 
                <button type="button" class="close" @click="confirmed = true; indice = index; validarInput()">
                    <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                </button>
              </div>
            </div>
            <div class="mb-3">
              <label class="file">Documento Anexo<v-icon class="ml-3" name="upload" scale="1.5"/>
                  <input @change="onFileChangeDocument($event)" type="file">
                  <div class="file-selected" v-if="monitoringActivity.document">
                  {{monitoringActivity.documentFile.name}}
                  </div>
              </label> 
            </div>
            <div>
            <button @click="confirmedInfo = true; validarInputInfo()" class="app-btn app-btn--green w-100">
                Enviar Información
            </button>
            </div>
        </div>
      </div>
    </div>


    <!-- Error Modal -->
    <div v-if="error != ''" class="error-modal">
      <div @click="error = ''" class="backdrop"></div>
      <div class="modal-box">
        <div class="app-icon mb-2">
          <v-icon name="exclamation-triangle" scale="2"/>
        </div>
        <div class="mb-4">
          {{error}}
        </div>
        <div>
          <button @click="error = ''" class="app-btn w-100">Continuar</button>
        </div>
      </div>
    </div>


    <div v-if="confirmed == false" class="error-modal">
      <div @click="confirmAccept = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Esta seguro de borrar el documento?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAccept = true; confirmed = true; borrarDocumento(indice)" class="app-btn app-btn">ACEPTAR</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAccept = false; confirmed = true" class="app-btn app-btn--blue">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="confirmedInfo == false" class="error-modal">
      <div @click="confirmAcceptInfo = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Esta seguro de enviar la información?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAcceptInfo = true; confirmedInfo = true; sendRequest()" class="app-btn app-btn">ACEPTAR</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAcceptInfo = false; confirmedInfo = true" class="app-btn app-btn--blue">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Screen Loader -->
    <div v-if="loading" class="screen-loader">
      <div class="spinner">
        <v-icon name="circle-notch" scale="3"/>
      </div>
    </div>

  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';
import axios from "axios";

export default {
  data(){
    return {
      date: new Date(),
      options: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      confirmAccept: false,
      confirmed: true,
      confirmAcceptInfo: false,
      confirmedInfo: true,
      arrayDocuments: [],
      monitoringActivity: {
        title: '',
        comments: '',
        document: '',
        documentFile: '',
        solicitudSupervisionObra: false
      },
      loading: false,
      error: ''
    }
  },
  methods: {
    borrarDocumento(indice){
      this.arrayDocuments.splice(indice,1);     
    },
    validarInput(){
      this.confirmed = false;
        return;        
    },
    validarInputInfo(){
      this.confirmedInfo = false;
        return;        
    },
    sendRequest(){

      if (this.monitoringActivity.title == '') {
        this.error = 'Debes agregar un nombre de la actividad de supervisión de obra.';
        return;
      }

      if (this.monitoringActivity.comments == '') {
        this.error = 'Debes agregar una descripción de la actividad de supervisión de obra.';
        return;
      }

      this.loading = true;

      let monitoringActivity = {
        "title":this.monitoringActivity.title,
        "comments":this.monitoringActivity.comments,
        "idRequest":this.requestDetail.id,
        "document":this.monitoringActivity.document,
        "updateDate":new Date(),
        "createDate": new Date(),
        "origenPeticion":"cliente"
      }
      
      axios.post("monitoringActivitiy/add", monitoringActivity, {
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json' }
      })
      .then((result) => {
        if (this.arrayDocuments.length > 0) {
          for (let i = 0; i < this.arrayDocuments.length; i++) {
            this.arrayDocuments[i].idMonitoringActivitiy = result.data.id;
          }
          this.sendDesignMonitoringDocument(0);
        }else{
          this.loading = false;
          this.$router.go(-1);
        }
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.';
      })
    },
    sendDesignMonitoringDocument(index){
      let newObjectMonitoringDocument = {
        "anexo":this.arrayDocuments[index].anexo,
        "description":this.arrayDocuments[index].description,
        "idMonitoringActivitiy":this.arrayDocuments[index].idMonitoringActivitiy,
        "status":'Activo',
        "editedDate":new Date(),
        "createdDate":new Date()
      }

      axios.post("monitoringActivitiyDocument/add/" + this.requestDetail.id, newObjectMonitoringDocument, {
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}
      })
      .then((result) => {
        if (index < this.arrayDocuments.length - 1) {
          this.sendDesignMonitoringDocument(index + 1);
        }else{
          this.loading = false;
          this.$router.go(-1);
          return;
        }
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tardeee.';
        return;
      })

    },
    onFileChangeDocument(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {

        let newDesignDocument = {
          "anexo":reader.result,
          "description":files.name,
          "idMonitoringActivitiy":1,
          "status":'Activo'
        }

        this.arrayDocuments.push(newDesignDocument);

      };

      reader.onerror = function (error) {
        console.log('Error: ', error);
      };

    },
    onFileChangeDocumentOld(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.monitoringActivity.document  = reader.result;
      };

      reader.onerror = function (error) {
        console.log('Error: ', error);
      };

      this.monitoringActivity.documentFile = files;
    }
  },
  computed: {
    ...mapState({
      requestDetail: state => state.requestDetail
    })
  }
}
</script>

<style lang="scss">
.form {
  padding: 50px 0;  
}
</style>